import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Tab, TextField } from "@mui/material";
import { TableWithSearchAndSortEngine } from "../utils/table";
import { formatDateWithMin } from "../../utils/date";
import { useEffect, useState } from "react";
import { URLS } from "../../env/urls";
import { openGlobalSnack } from "../utils/snack";
import { sendServerRequest } from "../../server/request";
import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import { userGetInfo, UserInfo } from "../../user/info";
import { CircularLoading } from "../utils/loading";
import { SelectFromItems } from "../utils/forms/select";
import CloseIcon from '@mui/icons-material/Close';
import { CltMarginInfo, CltPropostalInfo, SimulationResult } from "./types";
import { justNumbers } from "../../utils/justnumbers";
import { formatPhone, normalizePhone } from "../../utils/phone";
import { formatCPF } from "../../utils/formatcpf";
import { isValidEmail } from "../../utils/checkemail";
import { isValidRandomPixKey } from "../../utils/isvalidrandompix";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { formatBirthDate, isValidBrDate } from "../../utils/birthdate";
import { CltPropostal } from "./ cltpropostal";
import { CltElibility } from "./clteligibilidade";
import { CltBotPropotalSupport } from "./botproposal";

function getFirstName(name:string){
   const names=name.split(' ');
   return `${names[0].slice(0,1).toUpperCase()}${names[0].slice(1).toLowerCase()}` 
}


export enum CltWantSupportStatus{
   start='start',
   paid='paid',
   inSupport='inSupport',
   canceled='canceled',
   waiting='waiting',
   propostalCreated='propostalCreated',
}

function CltStatusToPTBR(status: CltWantSupportStatus): string {
    switch (status) {
        case CltWantSupportStatus.start:
            return "Iniciado";
        case CltWantSupportStatus.paid:
            return "Pago";
        case CltWantSupportStatus.inSupport:
            return "Em atendimento";
        case CltWantSupportStatus.canceled:
            return "Cancelado";
        case CltWantSupportStatus.waiting:
            return "Aguardando";
        case CltWantSupportStatus.propostalCreated:
            return "Proposta criada";
        default:
            return "Desconhecido";
    }
}



function ptBrToCltStatus(label: string): CltWantSupportStatus | null {
    switch (label) {
        case "Iniciado":
            return CltWantSupportStatus.start;
        case "Pago":
            return CltWantSupportStatus.paid;
        case "Em atendimento":
            return CltWantSupportStatus.inSupport;
        case "Cancelado":
            return CltWantSupportStatus.canceled;
        case "Aguardando":
            return CltWantSupportStatus.waiting;
        case "Proposta criada":
            return CltWantSupportStatus.propostalCreated;
        default:
            return null;
    }
}

export function CLT(){
     const [loading,setLoading]=useState(false);
     const [user,setUser]=useState<undefined|UserInfo>(undefined);
     const [showData,setData]=useState<Array<any>|null>(null);
     const [tabValue,setTabValue]=useState('1');
     const [searchStatus,setSearchStatus]=useState<CltWantSupportStatus|null>(null);
     useEffect(()=>{
        if(!user){
             userGetInfo().then(e=>{
                if(e){
                    setUser(e);
                }else{
                    openGlobalSnack('Erro ao carregar','error');
                }
             }).catch(e=>{
               openGlobalSnack('Erro ao carregar','error');
             });
        }
     },[]);
     useEffect(()=>{
       if(loading||!user)
        return;
       setLoading(true);
     },[searchStatus])
     useEffect(()=>{
            if(!loading)
                 return;
            if(!user)
                return;            
            sendServerRequest("POST",URLS.clt.list,searchStatus?{
                status:searchStatus
            }:undefined).then(e=>{
               setData(e.data.data.list);
               setLoading(false);
            }).catch(e=>{
                
                openGlobalSnack('Erro ao carregar propostas','error');
                setLoading(false);
            });        
        },[loading]);
    return (
        <div style={{textAlign:'center'}}>
            <div>
                <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={(e,v)=>setTabValue(v)} centered={true}  aria-label="lab API tabs example">
                        <Tab label="Clientes" value="1" />
                        <Tab label="Propostas" value="2" />
                         <Tab label="Eligibilidade" value="3" />
                         <Tab disabled={!Boolean(user?.permission?.can_support_clt_bot)} label="Propostas Bot" value="4" />

                    </TabList>
                    </Box>
                    <TabPanel value="1">
                        {!user?<CircularLoading/>:<div>
                    <h1 style={{marginTop:10,marginBottom:30,fontSize:25}}>Empréstimo CLT</h1>
                    
                    <div>
                    <div style={{margin:'auto',marginTop:'20px',marginBottom:'15px',maxWidth:'250px'}}>
                         <SelectFromItems defaultValue={searchStatus?CltStatusToPTBR(searchStatus):undefined} label="Status" onChangeItem={(u)=>{setSearchStatus(ptBrToCltStatus(u))}} items={Object.values(CltWantSupportStatus).map(i=>CltStatusToPTBR(i))}/>
                         <IconButton
                         disabled={!Boolean(searchStatus)}
                         color="info"
                         onClick={()=>setSearchStatus(null)}
                         ><CloseIcon sx={{fontSize:'50px'}}/></IconButton>
                    </div>
                   
                    <LoadingButton loading={loading} variant="contained" sx={{marginBottom:"15px"}}
                    onClick={()=>setLoading(true)}
                    >Pesquisar Chamados</LoadingButton>
                    {showData?<Propostals userId={user?.id||0} list={showData} updatePropostals={()=>{setLoading(true)}}/>:null}    
                   </div>
                </div>}
                    </TabPanel>
                    <TabPanel value="2"><CltPropostal/></TabPanel>
                    <TabPanel value="3"><CltElibility/></TabPanel>
                    <TabPanel value="4"><CltBotPropotalSupport/></TabPanel>
                </TabContext>
                
            </div>
        </div>
    )
}

function Propostals({list,updatePropostals,userId}:{list:Array<any>,updatePropostals:Function,userId:number}){
    const [selectedPropostal,setSelectedPropostal]=useState(null);
    
    return  (<div style={{textAlign:'center'}}>
             {list.length==0?<p>Sem Clientes</p>:<TableWithSearchAndSortEngine
             
             items={list} header={[
             {label:'Nome',id:'client_name',allowSort:false,showValue:(i)=>i.name},
             {label:'CPF',id:'cpf',showValue:(i)=>i.cpf},
              
              {label:'Telefone',id:'phone',showValue:(i)=>normalizePhone(i.phone),hidden:true},
             {label:'Status',id:'status',showValue:(i)=>CltStatusToPTBR(i.status),allowSort:true},
             {label:'Fonte',id:'souce',allowSort:true},
             {label:'Data',id:'created_at',showValue:(i)=>formatDateWithMin(i.createdAt),allowSort:true},
             {label:'Ver Mais',id:'see_moro',showValue:(i)=>{return (<Button onClick={()=>{
                 setSelectedPropostal(i);
             }} variant="contained">Ver Mais</Button>)}}
           ]}
          
           />}
            <CompleteInfo userId={userId} close={()=>{setSelectedPropostal(null)}} updatePropostals={updatePropostals} propostal={selectedPropostal}/>
        </div>)
}



function CompleteInfo({close,propostal,updatePropostals,userId}:{close:Function,propostal:any,updatePropostals:Function,userId:number}){
   const [loading,setLoading]=useState(false);
   const [usePropostal,setUseProPostals]=useState<any>(null);
   const [simulationResult,setSimulationResult]=useState<undefined|SimulationResult|any>(undefined);
   const [loadingTotalInfo,setLoadingTotalInfo]=useState(false);
   const [completePropostalInfo,setCompletePropostalInfo]=useState<any>(undefined);
   useEffect(()=>{
      setUseProPostals(propostal);
      setSimulationResult(undefined);
   },[propostal]);
   useEffect(()=>{
     if(!usePropostal)return;
     if(usePropostal.support_user_id){
          setLoadingTotalInfo(true);
     }
   },[usePropostal]);
   useEffect(()=>{
       if(!simulationResult)return;
   },[simulationResult])
   useEffect(()=>{
      if(loading){
          if(!propostal.support_user_id){
               sendServerRequest("POST",URLS.clt.addSupport+usePropostal?.id).then(e=>{
               openGlobalSnack('Suporte Adicionado','success');
               updatePropostals();
               const newProp=Object.assign({},usePropostal);
               newProp.support_user_id=userId;
               newProp.status=CltWantSupportStatus.inSupport;
               setUseProPostals(newProp);
            
               setLoading(false);
            }).catch(e=>{
                const status=e.target.status;
                if(status==403){
                    const res=JSON.parse(e.target.response);
                    openGlobalSnack(`Error: ${res.error}`,'warning');
                }else if(status==401){
                    openGlobalSnack("Você foi deslogado, atualize a página.",'error');
                }else{

                    openGlobalSnack("Erro. Entre em contato com o suporte.",'error');
                }
                setLoading(false);
            });     
          }else{
             const newProp=Object.assign({},usePropostal);
             newProp.status=CltWantSupportStatus.propostalCreated;
             setUseProPostals(newProp);
             updatePropostals();
             setLoading(false);
          }
      }
   },[loading]);
   useEffect(()=>{
        if(!loadingTotalInfo)return;
        sendServerRequest('GET',`/server/clt/supportRow/${usePropostal?.id}`).then(e=>{
            setCompletePropostalInfo(e.data.data);
            setLoadingTotalInfo(false);
        }).catch(e=>{
           openGlobalSnack('Error ao carregar informacoes da proposta','error');
           setLoadingTotalInfo(false);
        });
   },[loadingTotalInfo]);
   return (
      <Dialog open={Boolean(propostal)}>
          <DialogTitle>{`Emprestimo CLT`}</DialogTitle>
          {loadingTotalInfo?<CircularLoading/>:<DialogContent>
            <div style={{display:simulationResult?'block':'none'}}>
                <IconButton onClick={()=>setSimulationResult(undefined)}><ArrowBackIcon sx={{fontSize:"50px"}}/></IconButton>
                <div style={{marginTop:'10px'}}></div>
                <PropostalField update={()=>{setSimulationResult(undefined);setLoading(true)}}  propostal={usePropostal} simulation={simulationResult}/>
            </div>
            <div style={{display:simulationResult?'none':'block'}}>
            <p style={{textAlign:'center',marginBottom:'10px'}}>{`Status: ${CltStatusToPTBR(usePropostal?.status||'')}`}</p>
            <p style={{textAlign:'center',marginBottom:'10px'}}>{`Banco: ${usePropostal?.bank||''}`}</p>
            <p style={{textAlign:'center',marginBottom:'10px'}}>{`Fonte: ${completePropostalInfo?.source||'Desconhecido'}`}</p>
           <DataCopy keey="Nome" value={completePropostalInfo?.name}/>
           <DataCopy keey={'CPF'} value={usePropostal?.cpf}/>
           <DataCopy keey={'Data de nascimento'} value={completePropostalInfo?.birth_date}/>
           <DataCopy keey={'Nome da mãe'} value={completePropostalInfo?.mother_name}/>
           
           {usePropostal?.support_user_id?<div>
                <DataCopy keey={'Telefone'} value={completePropostalInfo?.phone?normalizePhone(completePropostalInfo.phone):''}/>
                <div style={{textAlign:'center',marginTop:'10px',marginBottom:'10px'}}>
                <Button variant="contained"
                 onClick={()=>{
                     let msg=`Olá ${getFirstName(completePropostalInfo?.name || '')}, o novo empréstimo CLT já está disponível para você.`; 
                     if(completePropostalInfo?.source=='fgts'){
                           msg=`Olá${completePropostalInfo?.name?`, ${getFirstName(completePropostalInfo?.name || '')}`:''}! Recentemente você realizou o saque do seu FGTS conosco. Temos agora o empréstimo CLT disponível para você.`;
                      }else if(completePropostalInfo?.source=='faceads'){
                        msg=`Olá ${getFirstName(completePropostalInfo?.name || '')}, você clicou no nosso anúncio sobre o empréstimo CLT. Temos uma oferta de empréstimo disponível para você.`
                      }
                      window.navigator.clipboard.writeText(msg);
                      openGlobalSnack(`Mensagem copiada.`,'success');
                 }}
                >Copiar Mensagem De Atendimento</Button>
                <PropostalOrMargim createPropostal={setSimulationResult} propostal={completePropostalInfo}/>
                
           </div>
           </div>:
           <LoadingButton variant="contained" loading={loading} onClick={()=>setLoading(true)} fullWidth color='success'>Atender Cliente</LoadingButton>}
           </div>
          </DialogContent>}
          <DialogActions>
            <Button disabled={loading} variant="contained"
              onClick={()=>{
                 close();
              }}
            >Sair</Button>
          </DialogActions>
      </Dialog>
   )
}

function PropostalOrMargim({propostal,createPropostal}:{propostal:any,createPropostal:Function}){
    const [loading,setLoading]=useState(false);
    const [findedPropostal,setFindedPropostal]=useState<undefined|CltPropostalInfo>(undefined);
    useEffect(()=>{
       if(!loading){
           setLoading(true);
       }
    },[propostal]);
    useEffect(()=>{
       if(!loading||!propostal)return;
       sendServerRequest('GET',`/server/clt/supportRow/${propostal.id}`).then(e=>{
          const pr:undefined|CltPropostalInfo=e.data.data.propostal;

          setFindedPropostal(pr);
          setLoading(false);

       }).catch(e=>{
           openGlobalSnack('Erro ao carregar suporte, atualize a página','error');

       });
    },[loading])
    return (
        <div>
            {loading?<CircularLoading/>:<div>
                {findedPropostal?<div style={{textAlign:'center'}}>
                 <p>Proposta</p>
                 <p>{`Status ${findedPropostal.status}`}</p> 
                 <p>{`Parcelas ${findedPropostal.numberOfPayments}`}</p>    
                 <p>{`Valor recebido R$ ${(findedPropostal.liquidValue/100).toFixed(2)}`}</p>
                 <DataCopy keey='Link' value={findedPropostal.link}/>
                 <DataCopy keey='Link de Ligação' value={findedPropostal?.callLink}/>
                </div>:<Margin createPropostal={createPropostal} propostal={propostal}/>}
            </div>}
        </div>
    )
}


function formatPix(pixType:string,value:string){
    if(pixType=='TELEFONE'){
        return formatPhone(justNumbers(value));
    }else if(pixType=='EMAIL'){
        return value.toLowerCase().trim();
    }else if(pixType=='ALEATORIA'){
        return value.trim();
    }
    return value;
}
function checkPix(pixType:string,value:string){
  if(pixType=='CPF'||!value)return true;
  if(pixType=='TELEFONE'){
        return justNumbers(value).length==11;
    }else if(pixType=='EMAIL'){
        return isValidEmail(value);
    }else if(pixType=='ALEATORIA'){
        return isValidRandomPixKey(value)
    }
}
function normalizePix(pixType:string,value:string){
  if(pixType=='CPF'||!value)return justNumbers(value);
  if(pixType=='TELEFONE'){
        return justNumbers(value);
    }else if(pixType=='EMAIL'){
        return value.toLowerCase().trim();
    }else if(pixType=='ALEATORIA'){
        return value.trim();
    }
}

function PropostalField({propostal,simulation,update}:{propostal:any,simulation:any,update:Function}){
    const [name,setName]=useState('');
    const [motherName,setMotherName]=useState('');
    const [phone,setPhone]=useState('');
    const [gender,setGender]=useState('');
    const [pixType,setPixType]=useState('');
    const [pix,setPix]=useState('');
    const [cep,setCep]=useState('');
    const [loadingCep,setLoadingCep]=useState(false);
    const [uf,setUf]=useState('');
    const [city,setCity]=useState('');
    const [neighborhood,setNeighborhood]=useState('');
    const [street,setStreet]=useState('');
    const [streetNumber,setStreetNumber]=useState('');
    const [email,setEmail]=useState('');
    const [birthDate,setBirthDate]=useState('');
    const [loadingCreate,setLoadingCreate]=useState(false);
    const [loadingInfo,setLoadingInfo]=useState(false);

    useEffect(()=>{

        if(!simulation)return;
        setLoadingInfo(true);
    },[simulation]);

    useEffect(()=>{
      if(!loadingInfo)return;
      sendServerRequest('GET',`${URLS.clt.rowInfo}/${propostal.id}`).then(e=>{
            const data=e.data.data.clientInfo;
            setName(data.name?.toUpperCase());
            setMotherName(data.mother_name?.toUpperCase());
            setPhone(formatPhone(normalizePhone(data.phone||'')));
            setBirthDate(formatBirthDate(data.birth_date));
            setLoadingInfo(false);
      }).catch(e=>{
            console.log(e);
            setName(propostal.name?.toUpperCase());
            setMotherName(propostal.mother_name?.toUpperCase());
            setPhone(formatPhone(normalizePhone(propostal.phone||'')));
            setBirthDate(formatBirthDate(propostal.birth_date));
            setLoadingInfo(false);
      });
    },[loadingInfo]);

    useEffect(()=>{
       if(pixType=='CPF'){
           setPix(formatCPF(propostal.cpf));
       }else{
          setPix('');
       }
       
    },[pixType]);
    useEffect(()=>{
       if(!loadingCreate)return;
       createPropostal();
    },[loadingCreate])
    useEffect(()=>{
         if(cep.length<8)return;
         setLoadingCep(true);
    },[cep]);
    useEffect(()=>{
      if(!loadingCep||cep.length<8)return;
      sendServerRequest('GET',`https://viacep.com.br/ws/${cep}/json/`).then(e=>{
         const data=e.data;
         if(data.uf){
             setUf(data.uf);
         }
         if(data.localidade){
            setCity(data.localidade);
         }
         if(data.logradouro){
            setStreet(data.logradouro);
         }
         if(data.bairro){
            setNeighborhood(data.bairro);
         }
         setLoadingCep(false);
         
      }).catch(e=>{
          setLoadingCep(false);
      })
    },[loadingCep])
    return (
        <div style={{textAlign:'center'}}>
            <Div field="Informações pessoais"/>
            <div style={{marginTop:'10px'}}>
                <TextField disabled value={propostal?.cpf?formatCPF(propostal.cpf):''} fullWidth label='CPF'/>
               <TextField disabled={loadingCreate} error={Boolean(name)&&(name?.length<3||name?.split(' ').length<2)} sx={{marginTop:"10px"}} fullWidth value={name} onChange={(v)=>{setName(v.target.value.toUpperCase())}} label='Nome'/>
               <TextField disabled={loadingCreate} error={Boolean(motherName)&&(motherName?.length<3||motherName?.split(' ').length<2)} fullWidth value={motherName} onChange={(v)=>{setMotherName(v.target.value.toUpperCase())}} sx={{marginTop:"10px"}} label='Nome da mãe'/>
            </div>
            <div style={{marginTop:'10px'}}>
               
              <div style={{marginTop:'10px'}}>
                <div style={{width:'200px',display:'inline-block'}}>
                <SelectFromItems disabled={loadingCreate} defaultValue={gender} label="Sexo" items={['Masculino','Feminino']} onChangeItem={(v)=>{setGender(v)}}/>
               </div>
               <TextField disabled={loadingCreate} error={Boolean(birthDate)&&!isValidBrDate(birthDate)} sx={{marginLeft:'5px'}} value={birthDate} label='Data de nascimento' helperText='dd/mm/yyyy' onChange={(v)=>setBirthDate(formatBirthDate(v.target.value))} />
              </div>
            </div>
            <Div field="Contato"/>
            <div style={{marginTop:'10px'}}>
               <TextField disabled={loadingCreate} value={phone} label='Telefone' onChange={(v)=>{setPhone(formatPhone(justNumbers(v.target.value).substring(0,11)))}}/>
               <TextField disabled={loadingCreate} sx={{marginLeft:"10px"}}  error={Boolean(email)&&!isValidEmail(email)}  onChange={(v)=>{setEmail(v.target.value.toLowerCase().trim())}} helperText='Digite um email.' label='Email'/>
            </div>
            <Div field="Conta para deposito"/>
            <div style={{marginTop:'10px'}}>
               <div style={{width:'200px',display:'inline-block'}}>
                  <SelectFromItems disabled={loadingCreate} label="Tipo Pix" defaultValue={pixType} items={['CPF','EMAIL','TELEFONE','ALEATORIA']} fullWidth={true} onChangeItem={(v)=>{setPixType(v)}}/>
               </div>
               <TextField  error={!checkPix(pixType,pix)} helperText="Digite um pix."   sx={{marginLeft:"10px"}} value={pix} disabled={!Boolean(pixType)||pixType=='CPF'||loadingCreate} label='Chave PIX' onChange={(v)=>{setPix(formatPix(pixType,v.target.value))}}/>
            </div>
            <Div field="Endereço"/>
            <div style={{marginTop:'10px'}}>
               <TextField disabled={loadingCreate} value={cep} onChange={(v)=>setCep(justNumbers(v.target.value).substring(0,8))} label='CEP'/>
               <TextField sx={{marginLeft:"10px"}} value={uf} disabled={loadingCep||loadingCreate} onChange={(v)=>{setUf(v.target.value.toUpperCase().substring(0,2))}} label='UF'/>
            </div>
             <div style={{marginTop:'10px'}}>
               <TextField label='Cidade' value={city} onChange={(v)=>{setCity(v.target.value)}} disabled={loadingCep||loadingCreate}/>
               <TextField sx={{marginLeft:"10px"}} onChange={(v)=>setNeighborhood(v.target.value)} value={neighborhood} disabled={loadingCep||loadingCreate} label='Bairro'/>
            </div>
             <div style={{marginTop:'10px'}}>
              <TextField  value={street} onChange={(v)=>{setStreet(v.target.value)}} disabled={loadingCep||loadingCreate} label='Rua'/>
               <TextField sx={{marginLeft:"10px"}} disabled={loadingCreate} value={streetNumber} onChange={(v)=>{setStreetNumber(justNumbers(v.target.value))}} label='Numero'/>
            </div>
            <LoadingButton loading={loadingCreate} onClick={()=>{setLoadingCreate(true)}} disabled={!canCreate()} fullWidth variant="contained" sx={{marginTop:'10px',marginBottom:'15px'}}>Gerar Proposta</LoadingButton>
        </div>
    )
    function Div({field}:{field:string}){
        return (<div>
            <p>{field}</p>
            <Divider sx={{marginTop:'4px',marginBottom:'4px'}}/>
        </div>)
    }
    function canCreate(){
        if(!name)return false;
        if(name.length<3||name.split(' ').length<2)return false;
        if(!motherName)return false;
        if(motherName.length<3||motherName.split(' ').length<2)return false;

        if(!pix||!checkPix(pixType,pix))return false;
        if(!email||!isValidEmail(email))return false;
        if(!gender)return false;
        if(justNumbers(phone).length!==11)return false;
        if(!isValidBrDate(birthDate))return false;
        if(!uf||!street||!streetNumber||!city||!neighborhood)return false;
        return true;
    }
    function createPropostal(){
         const sendData={
             name,
             motherName,
             birthDate,
             email,
             gender:gender=='Masculino'?'male':'female',
             uf,
             street,
             streetNumber,
             city,
             neighborhood,
             phone:justNumbers(phone),
             pix:normalizePix(pixType,pix),
             cep,
             pixType:pixToPixType(pixType),
             simulationId:simulation?.simulateId,
         }
         sendServerRequest(`POST`,`/server/clt/createPropostal/${propostal?.id}`,sendData).then(e=>{
             update();
             setLoadingCreate(false);
         }).catch(e=>{
             const status=e.target.status;
             if(status==403){
                 const res=JSON.parse(e.target.response);
                 openGlobalSnack(`Error: ${res.error}`,'warning');
             }else if(status==401){
                   openGlobalSnack("Você foi deslogado, atualize a página.",'error');
             }else{

                   openGlobalSnack("Algum erro aconteceu ao gerar proposta, verifique as informações, ou atualize a página.",'error');
             }
            
             setLoadingCreate(false);
         })
    }
}

function v8DateToNormalDate(d:string){
   const ds=d.split('-');
   if(ds.length!=3)return d;
   return `${ds[2]}/${ds[1]}/${ds[0]}`;
}

function pixToPixType(pix:string){
  if(pix=='TELEFONE')return 'phone';
  if(pix=='CPF')return 'cpf';
  if(pix=='EMAIL')return 'email';
  return 'random';
}
function Margin({propostal,createPropostal}:{propostal:any,createPropostal:Function}){
    const [loadingSimulate,setLoadingSimulate]=useState(false);
    const [loading,setLoading]=useState(false);
    const [needConsult,setNeedConsult]=useState(false);
    const [elegebilityStatus,setElegebilityStatus]=useState<undefined|string>(undefined);
    const [data,setData]=useState<CltMarginInfo|undefined>(undefined);
    const [avaiableInstallments,setAvaiableInstallments]=useState<Array<string>>([]);
    const [selectedInstallment,setSelectedInstallment]=useState<number|undefined>(undefined);
    const [maxMargin,setMaxMargin]=useState(0);
    const [parcelValue,setParcelValue]=useState(0);
    const [simulationResult,setSimulationResult]=useState<undefined|SimulationResult|any>(undefined);
    const [consuting,setConsulting]=useState(false);
    useEffect(()=>{
       if(!consuting)return;
       sendServerRequest('POST',`/server/clt/consult/elegebility`,{
          cpf:propostal.cpf,
          phone:normalizePhone(propostal.phone),
       }).then(e=>{
          getInfo();
       }).catch(e=>{
           if(e?.target?.status==403){
               const r=JSON.parse(e.target.response);
               openGlobalSnack(r.error,'warning');
               setConsulting(false);
               return;
           }
           openGlobalSnack('Error, atualize a pagina','error');
           setConsulting(false);
       });
    },[consuting])
    useEffect(()=>{
        getInfo();
    },[]);

    useEffect(()=>{
       updateData();
    },[data])
    useEffect(()=>{
       if(!loading)return;
       getMargin();
    },[loading]);
    useEffect(()=>{
       if(!data||!selectedInstallment)return;
       const maxmargin=(data.valueMax/selectedInstallment)-0.01;
       setMaxMargin(Math.min(maxmargin,parseFloat(data.marginMax)));
    },[selectedInstallment]);
    useEffect(()=>{
       setParcelValue(maxMargin);
    },[maxMargin])
    useEffect(()=>{
        if(!loadingSimulate)return;
        getSimulate();
    },[loadingSimulate])
    return (
        <div style={{textAlign:'center',marginTop:10}}>
             <h3 style={{marginTop:10,marginBottom:10}}>Simulação</h3>
             {loading?<CircularLoading/>:needConsult?<div>
                <LoadingButton loading={consuting} onClick={()=>setConsulting(true)} variant="contained">Consultar Eligibilidade</LoadingButton>
             </div>:Boolean(elegebilityStatus)?<div>
                <p>{`Status da consulta: ${elegebilityStatus}`}</p>
             </div>:<div>
                <SelectFromItems defaultValue={selectedInstallment?.toString()} items={avaiableInstallments} label="Parcelas" onChangeItem={(v)=>{
                    setSelectedInstallment(parseInt(v));
                }}/>
                {selectedInstallment?<div style={{marginTop:12}}>
                    <TextField  fullWidth type="number"
                    helperText={`Valor máximo ${(maxMargin||0).toFixed(2)}`}
                    error={parcelValue>maxMargin}
                    label="Valor da parcela"
                    value={(parcelValue||0).toFixed(2)}
                    onChange={(v)=>{
                        const val=parseInt(justNumbers(v.target.value))/100;
                        setParcelValue(val);  
                    }}
                    />
                    <LoadingButton loading={loadingSimulate} onClick={()=>setLoadingSimulate(true)} disabled={parcelValue>maxMargin} variant="contained">Simular</LoadingButton>
                    {simulationResult?<div style={{marginTop:10}}>
                        <p>{`${simulationResult.installments} x de R$ ${simulationResult.value?.toFixed(2)}`}</p>
                        <p>{`Recebe R$ ${simulationResult.total?.toFixed(2)}`}</p>
                        <p>{`Primeiro pagamento: ${simulationResult.firstDue}`}</p>
                        <p style={{color:'green'}}>{`Sua comissao: R$ ${simulationResult.comission.toFixed(2)}`}</p>
                        <Button variant="contained" onClick={()=>{
                             window.navigator.clipboard.writeText(`Você irá receber R$ ${simulationResult.total?.toFixed(2)}\n${simulationResult.installments} x de R$ ${simulationResult.value?.toFixed(2)} descontado direto em folha.\nTem interesse?`);
                             openGlobalSnack('Copiado','success');
                        }}>Copiar Mensagem</Button>
                        <Button fullWidth onClick={()=>{createPropostal(simulationResult)}} variant="contained" sx={{marginTop:10}}>Finalizar Proposta</Button>
                    </div>:null}
                </div>:null}
            </div>}
        </div>
    )
    function IInfo({field,value}:{field:string,value:string}){
       return (
          <div style={{display:'flex',justifyContent:'center'}}>
             <p style={{fontSize:'14px'}}>{`${field}:`}</p>
             <p style={{fontSize:'18px'}}>{value}</p>
          </div>
       )
    }
    function getInfo(){
         if(!propostal)return;
         setLoading(true);
    }
    function getMargin(){
         const id:number=propostal.id;
         sendServerRequest('GET',`/server/clt/margin/${id}`).then(e=>{
            const data:CltMarginInfo|undefined=e.data.data.simulate;
            if(!data){
                const status=e.data.data.status;
                if(status){
                    setElegebilityStatus(status);
                    setNeedConsult(false);
                }else{
                    setElegebilityStatus(undefined);
                    setNeedConsult(true);
                }
                
                setLoading(false);
                return; 
            }
            setData(data);
         }).catch(e=>{
            setLoading(false);
            openGlobalSnack('Error ao carregar margem','error');
         });
    }
    function getSimulate(){
         const id:number=propostal.id;
         sendServerRequest('GET',`/server/clt/simulate/${id}/${selectedInstallment}/${parcelValue?.toFixed(2)}`).then(e=>{
            const data:SimulationResult=e.data.data.simulate;
            setSimulationResult(data);
            setLoadingSimulate(false);
         }).catch(e=>{
            setLoadingSimulate(false);
            openGlobalSnack('Error ao simular','error');
         });
    }
    function updateData(){
         if(!data)return;
         const _avaiableInstallments:Array<string>=[];
         for(let ins of data.avaiableInstallments){
            if(ins>data.installmentsMax)
                 continue;
            if(ins<data.installmentsMin)
                continue;
            _avaiableInstallments.push(ins.toString());    
         }
         setAvaiableInstallments(_avaiableInstallments);
         setLoading(false);
    }

}

function DataCopy({keey,value}:{keey:string,value?:string}){
  if(!value||!keey)
    return null;
  return (
    <div style={{marginBottom:'22px',textAlign:'center'}}>
      <p>{`${keey}: ${value}`}</p>
      <Button variant="contained" onClick={()=>{
         window.navigator.clipboard.writeText(value);
         openGlobalSnack(`${keey} copiado.`,'success');
      }}>Copiar</Button>
    </div>
  )
}